module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oneTenthDown),
      expression: "oneTenthDown"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334455"
    },
    domProps: {
      "checked": Array.isArray(_vm.oneTenthDown) ? _vm._i(_vm.oneTenthDown, null) > -1 : (_vm.oneTenthDown)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.oneTenthDown,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.oneTenthDown = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.oneTenthDown = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.oneTenthDown = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oneTenthUp),
      expression: "oneTenthUp"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334456"
    },
    domProps: {
      "checked": Array.isArray(_vm.oneTenthUp) ? _vm._i(_vm.oneTenthUp, null) > -1 : (_vm.oneTenthUp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.oneTenthUp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.oneTenthUp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.oneTenthUp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.oneTenthUp = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._v("\n                 \n                \n            Report review count drops greater than or equal to\n            "), _c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "90px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviewCountDropMinimumThreshold),
      expression: "reviewCountDropMinimumThreshold"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "size": "3"
    },
    domProps: {
      "value": (_vm.reviewCountDropMinimumThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviewCountDropMinimumThreshold = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("reviews")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334455"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "warning circle icon"
  }), _vm._v("Alerts:")]), _vm._v(" \n                warn at every "), _c('b', [_vm._v("0.1 rating drop")]), _vm._v(" not just "), _c('i', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "yellow fitted star outline icon"
  }), _c('i', {
    staticClass: "yellow fitted half star icon"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "checkbox334456"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "checkmark circle icon"
  }), _vm._v("Notifications:")]), _vm._v(" \n                  by "), _c('b', [_vm._v("0.1 improvements")]), _vm._v(" not just "), _c('i', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "yellow fitted star outline icon"
  }), _c('i', {
    staticClass: "yellow fitted half star icon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ae308a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/StarRatingRecentChangeConfig.vue
// module id = 720
// module chunks = 2